import { useEffect } from 'react';
import { ACTION_TYPES, useQuestionAnswerCategoryDispatch, useQuestionAnswerCategoryState } from './question-answer-category-context';
import QuestionAnswerAppService from '../../../../application/platform/apm/question-answer/question-answer-app-service';
import { IQuestionAnswerCategoryResponse } from '../../../../model/apm/question-answer/response/question-answer-category-response';
import { IQuestionAnswerCategoryAddEditRequest } from '../../../../model/apm/question-answer/request/question-answer-category-add-edit-request';
import { useActionRunner } from '../../../../hooks/use-action-runner';

export const useQuestionAnswerCategoryController = () => {
    const dispatch = useQuestionAnswerCategoryDispatch();
    const state = useQuestionAnswerCategoryState();
    const { isSaving, runSaving, run, showSuccess, confirmDelete } = useActionRunner();

    async function loadCategories() {
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });
        await run('Não foi possível carregar as categorias', async () => {
            dispatch({ type: ACTION_TYPES.setCategories, payload: await QuestionAnswerAppService.listCategories() });
        });
        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    useEffect(() => {
        loadCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function openDrawer(category?: IQuestionAnswerCategoryResponse) {
        dispatch({ type: ACTION_TYPES.openDrawer, payload: category });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IQuestionAnswerCategoryAddEditRequest) {
        const editing = state.drawer.category;
        return runSaving('Não foi possível salvar a categoria', async () => {
            await (editing ? QuestionAnswerAppService.editCategory(editing.id, request) : QuestionAnswerAppService.addCategory(request));
            showSuccess(editing ? 'Categoria atualizada com sucesso!' : 'Categoria cadastrada com sucesso!');
            closeDrawer();
            await loadCategories();
        });
    }

    function handleDelete(category: IQuestionAnswerCategoryResponse) {
        confirmDelete(`Tem certeza que deseja excluir a categoria "${category.description}"?`, () => run('Não foi possível excluir a categoria', async () => {
            await QuestionAnswerAppService.removeCategory(category.id);
            showSuccess('Categoria excluída com sucesso!');
            await loadCategories();
        }));
    }

    return { isSaving, openDrawer, closeDrawer, handleSave, handleDelete };
};
